import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import React, { useState, useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import {useNavigate} from 'react-router';
import {GithubPicker} from 'react-color';
import Grid from '@mui/material/Grid';
import {EM_SELF, EM_NEW, EM_OTHER, isalnum, JSP_ADD_USER, JSP_MOD_USER, c2js, CITY_ID_FORSSA, COUNTRY_ID_FI} from './Util.js'
import {SEC_LANG_NONE, SEC_LANG_FI, SEC_LANG_EN, SEC_LANG_SWE, SEC_LANG_SCI, SEC_LANG_ABBR} from './Trans.js';
import {PRI_LANG_FI, PRI_LANG_EN, PRI_LANG_SWE, PRI_LANG_SCI, PRI_LANG_ABBR} from './Trans.js';
import {CITY_LANG_FI, CITY_LANG_EN, CITY_LANG_SWE, getCityName} from './Trans.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

let saving = false;

function Settings() {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const navigate = useNavigate();

	const [changed, setChanged] = useState(false);
	
	const [settings, setSettings] = useState({
		id: 0,
		nick: '',
		first_name: '',
		last_name: '',
		city_id: CITY_ID_FORSSA,
		city: null,
		street_addr: '',
		city_addr: '',
		email: '',
		phone: '',
		allow_friend: 1,
		public_obs: 1,
		pri_spec_lang: 0,
		sec_spec_lang: 0,
		city_lang: 0,
		pwd_reset_req: 0,
		no_login: 0,
		trip1: 0,
		trip2: 0,
		trip3: 0,
		chk1_desc: '',
		chk2_desc: '',
		color1_desc: '',
		color2_desc: '',
		color1: 0,
		color2: 0,
		_access: 0,
		statewiz: 1,
		bl_notification: 0,
		speech_rec: 1,
		trip_snackbar: 1,
		def_country: COUNTRY_ID_FI,
	});

	function sanitizeTrip(id) {
		const _trip = gStorage.lists.triplist.list.find((tr) => tr.id === id);
		if (!_trip) 
			return 0;

		return id;
	}

	function globToSettings() {
// 		setSavedUser(JSON.parse(JSON.stringify(gStorage.conn.user)));
		const _city_id = gStorage.conn.user.city_id ? gStorage.conn.user.city_id : CITY_ID_FORSSA;

		setSettings({
			id: gStorage.conn.user.id,
			nick: gStorage.conn.user.nick,
			first_name: gStorage.conn.user.first_name,
			last_name: gStorage.conn.user.last_name,
			city_id: _city_id,
			city: gStorage.lists.citylist.list.find(option => option.id === _city_id),
			street_addr: gStorage.conn.user.street_addr,
			city_addr: gStorage.conn.user.city_addr,
			email: gStorage.conn.user.email,
			phone: gStorage.conn.user.phone,
			pri_spec_lang: gStorage.conn.user.pri_spec_lang,
	      		sec_spec_lang: gStorage.conn.user.sec_spec_lang,
			city_lang: gStorage.conn.user.city_lang,
			allow_friend: gStorage.conn.user.allow_friend === 1 ? 1 : 0,
			public_obs: gStorage.conn.user.public_obs === 1 ? 1 : 0,
			pwd_reset_req: gStorage.conn.user.pwd_reset_req === 1 ? 1 : 0,
	      		no_login: gStorage.conn.user.no_login === 1 ? 1 : 0,
			trip1: sanitizeTrip(gStorage.conn.user.trip1),
			trip2: sanitizeTrip(gStorage.conn.user.trip2),
			trip3: sanitizeTrip(gStorage.conn.user.trip3),
			chk1_desc: gStorage.conn.user.chk1_desc,
			chk2_desc: gStorage.conn.user.chk2_desc,
			color1_desc: gStorage.conn.user.color1_desc,
			color2_desc: gStorage.conn.user.color2_desc,
			color1: gStorage.conn.user.color1,
			color2: gStorage.conn.user.color2,
			_access: gStorage.conn.user._access,
			statewiz: gStorage.conn.user.statewiz,
			bl_notification: gStorage.conn.user.bl_notification,
			speech_rec: gStorage.conn.user.speech_rec,
			trip_snackbar: gStorage.conn.user.trip_snackbar,
			def_country: gStorage.conn.user.def_country,
		});
	}

	function initNew() {
// 		console.log('initNew', priLangList.find(option => option.id === PRI_LANG_FI));

		setSettings({
			...settings,
	      		city_id: CITY_ID_FORSSA,
	      		city: gStorage.lists.citylist.list.find(option => option.id === CITY_ID_FORSSA),
			pri_spec_lang: PRI_LANG_FI,
			sec_spec_lang: SEC_LANG_ABBR,
			city_lang: CITY_LANG_FI,
			allow_friend: 1,
			public_obs: 1,
			pwd_reset_req: 1,
			no_login: 0,
			trip1: 0,
			trip2: 0,
			trip3: 0,
			chk1_desc: '',
			chk2_desc: '',
			color1_desc: '',
			color2_desc: '',
			color1: 0,
			color2: 0,
			_access: 0,
			statewiz: 1,
			bl_notification: 0,
			speech_rec: 1,
			trip_snackbar: 1,
			def_country: COUNTRY_ID_FI,
		});
	};

	function initOther() {
		let user;

		user = gStorage.lists.userlist.list.find(option => option.id === gStorage.settings.id);
		if (!user) {
			alert('settings: no user for id', gStorage.settings.id);
			navigate('/', { replace: true });
		}

// 		console.log('initOther', gStorage.settings.id, user);
		const _city_id = user.city_id ? user.city_id : CITY_ID_FORSSA;

		setSettings({
			id: user.id,
			nick: user.nick,
			first_name: user.first_name,
			last_name: user.last_name,
			city_id: user.city_id,
			city: gStorage.lists.citylist.list.find(option => option.id === _city_id),
			street_addr: user.street_addr,
			city_addr: user.city_addr,
			email: user.email,
			phone: user.phone,
			pri_spec_lang: user.pri_spec_lang,
	      		sec_spec_lang: user.sec_spec_lang,
			city_lang: user.city_lang,
			allow_friend: user.allow_friend === 1 ? 1 : 0,
			public_obs: user.public_obs === 1 ? 1 : 0,
			pwd_reset_req: user.pwd_reset_req === 1 ? 1 : 0,
	      		no_login: user.no_login === 1 ? 1 : 0,
	      		trip1: sanitizeTrip(user.trip1),
			trip2: sanitizeTrip(user.trip2),
			trip3: sanitizeTrip(user.trip3),
			chk1_desc: user.chk1_desc,
			chk2_desc: user.chk2_desc,
			color1_desc: user.color1_desc,
			color2_desc: user.color2_desc,
			color1: user.color1,
			color2: user.color2,
			_access: user._access,
			statewiz: user.statewiz,
			bl_notification: user.bl_notification,
			speech_rec: user.speech_rec,
			trip_snackbar: user.trip_snackbar,
			def_country: user.def_country,
		});
	}

	useEffect(() => {
// 		console.log('settings constructor', gStorage.settings.em);

		switch (gStorage.settings.em) {
			case EM_SELF:
				globToSettings();
				break;
			case EM_NEW:
				initNew();
				break;
			case EM_OTHER:
				initOther();
				break;
			default:
				alert('settings: unknown edit mode', gStorage.settings.em);
				navigate('/', { replace: true });
				break;
		}
		// eslint-disable-next-line
	}, []);

	function handleCancel() {
// 		gStorage.conn.setUser(savedUser);
    		window.history.back();
	}

	function firstNameChanged(event) {
		setSettings({...settings, first_name: event.target.value});
		setChanged(true);
	}
	
	function validFirstName() {
		return settings.first_name && settings.first_name.length > 0 ? true : false;
	}

	function lastNameChanged(event) {
		setSettings({...settings, last_name: event.target.value});
		setChanged(true);
	}

	function validLastName() {
		return settings.last_name && settings.last_name.length > 0 ? true : false;
	}

	function cityChange(event, value) {
		setSettings({...settings, city_id: value ? value.id : 0});
		setChanged(true);
	}

	function streetAddrChanged(event) {
		setSettings({...settings, street_addr: event.target.value});
		setChanged(true);
	}

	function cityAddrChanged(event) {
		setSettings({...settings, city_addr: event.target.value});
		setChanged(true);
	}

	function emailChanged(event) {
		setSettings({...settings, email: event.target.value});
		setChanged(true);
	}

	function validEmail() {
		if (!settings.email)
			return true;

		if (settings.email.length <= 0)
			return true;

		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(settings.email) ? true : false;
	}

	function phoneChanged(event) {
		setSettings({...settings, phone: event.target.value});
		setChanged(true);
	}

	function validPhone() {
		if (!settings.phone)
			return true;

		if (settings.phone.length <= 0)
			return true;

		if (settings.phone.length >= 20)
			return false;

    		return settings.phone.search(/^(\+{1}\d{2,3}\s?[(]{1}\d{1,3}[)]{1}\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}$/) >= 0 ? true : false;
	}

	function primarySpecLangChanged(event) {
		setSettings({...settings, pri_spec_lang: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	function secondarySpecLangChanged(event) {
		setSettings({...settings, sec_spec_lang: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	function cityLangChanged(event) {
		setSettings({...settings, city_lang: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	function allowFriendChanged(event, value) {
		setSettings({...settings, allow_friend: value ? true : false});
		setChanged(true);
	}

	function publicObsChanged (event, value) {
		setSettings({...settings, public_obs: value ? 1 : 0});
		setChanged(true);
	}

	function saveSettings() {
		let _set = JSON.parse(JSON.stringify(settings));

		delete _set.city;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'save',
			data: {
				user: _set,
			}
		};

// 		console.log('saveSettings', msg);

		saving = 1;
		gStorage.conn.ws.send(msg, settingsRxWs);
	}

	function settingsRxWs(status, obj) {
// 		console.log('settingsRxWs:', status, obj);

		saving = 0;

		if (status !== COMM_OK) {
			alert('Settings Rx timeout!');
			return -1;
		}

		if (obj.cmd === 'user') {
			if (obj.op === 'save') {
				if (obj.result === 'OK') {
					let _set = JSON.parse(JSON.stringify(settings));

					delete _set.city;

					if (gStorage.settings.em === EM_SELF)
						gStorage.conn.setUser(_set);

					window.history.back();
				} else {
					alert('User save failed!');
				}
			} else if (obj.op === 'del') {
				if (obj.result === 'OK') {
					window.history.back();
				} else {
					alert('User delete failed!');
				}
			} else if (obj.op === 'password') {
				if (obj.result !== 'OK') {
					alert('Password reset failed!');
				}
			} else {
				console.error('settingsRxWs: unknown operation:', obj.op);
			}
		} else {
			console.error('settingsRxWs: unknown cmd', obj.cmd);
		}
	}

	const priLangList = [
		{id: PRI_LANG_FI,    name: t('common.fi')},
		{id: PRI_LANG_EN,    name: t('common.en')},
		{id: PRI_LANG_SWE,   name: t('common.swe')},
		{id: PRI_LANG_SCI,   name: t('common.sci')},
		{id: PRI_LANG_ABBR,  name: t('common.abbr')},
	];

	const secLangList = [
 		{id: SEC_LANG_NONE,  name: t('settings.none')},
		{id: SEC_LANG_FI,    name: t('common.fi')},
		{id: SEC_LANG_EN,    name: t('common.en')},
		{id: SEC_LANG_SWE,   name: t('common.swe')},
		{id: SEC_LANG_SCI,   name: t('common.sci')},
		{id: SEC_LANG_ABBR,  name: t('common.abbr')},
	];

	const cityLangList = [
		{id: CITY_LANG_FI,  name: t('common.fi')},
		{id: CITY_LANG_EN,  name: t('common.en')},
		{id: CITY_LANG_SWE, name: t('common.swe')},
	];

	function setGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	function nickChanged(event) {
		setSettings({...settings, nick: event.target.value});
		setChanged(true);
	}

	function validNick() {
		let i, l;

		l = settings.nick.length;
		if (l < 4)
			return false;

		if (l > 16)
			return false;

		for (i = 0; i < l; i++)
			if (!isalnum(settings.nick[i]))
				return false;

		return true;
	}

	function nick_object() {
		if (gStorage.settings.em === EM_NEW || gStorage.conn.user._access & JSP_MOD_USER) {
			return (
				<TextField 
					label={t('settings.nick')}
					variant="outlined"
					value={settings.nick}
					onChange={nickChanged}
					error={!validNick()}
					size="small" 
					style={{width: 300, margin: 8}}
					inputProps={{maxLength: 16}}
				/>
			);
		} else {
			return (
				<Typography variant={'h6'}>
					{settings.nick}
				</Typography>
			);
		}
	}

	function pwdResetReqChanged(event, value) {
		setSettings({...settings, pwd_reset_req: value ? 1 : 0});
		setChanged(true);
	}

	function noLoginChanged(event, value) {
		setSettings({...settings, no_login: value ? 1 : 0});
		setChanged(true);
	}

	/* ------------------------------------------------------------------ */

	function tripList1() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== settings.trip2 && trip.id !== settings.trip3))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

		return ret;
	}

	function trip1Changed(event) {
		setSettings({...settings, trip1: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	function tripList2() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== settings.trip1 && trip.id !== settings.trip3))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

		return ret;
	}

	function trip2Changed(event, trip) {
		setSettings({...settings, trip2: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	function tripList3() {
		let ret = [];

		gStorage.lists.triplist.list.forEach((trip, ind) => {
			if (trip.public_trip && trip.active && (trip.id === 0 || (trip.id !== settings.trip1 && trip.id !== settings.trip2))) {
				ret.push(<MenuItem key={trip.id} value={trip.id}>{t(trip.name)}</MenuItem>);
			}
		});

		return ret;
	}

	function trip3Changed(event, trip) {
		setSettings({...settings, trip3: parseInt(event.target.value, 10)});
		setChanged(true);
	}

	/* ------------------------------------------------------------------ */

	function chk1DescChanged(event) {
		setSettings({...settings, chk1_desc: event.target.value});
		setChanged(true);
	}

	function chk2DescChanged(event) {
		setSettings({...settings, chk2_desc: event.target.value});
		setChanged(true);
	}

	function color1DescChanged(event) {
		setSettings({...settings, color1_desc: event.target.value});
		setChanged(true);
	}

	function color2DescChanged(event) {
		setSettings({...settings, color2_desc: event.target.value});
		setChanged(true);
	}

	function c1bgColor() {
		if (!settings.color1 || !settings.color1_desc || settings.color1_desc.length <= 0)
			return '#ffffff';

		return c2js(settings.color1);
	}

	function color1Changed(color, event) {
		let c = (color.rgb.r << 16) | (color.rgb.g << 8) | color.rgb.b;
		setSettings({...settings, color1: c});
		setChanged(true);
	}

	function c2bgColor() {
		if (!settings.color2 || !settings.color2_desc || settings.color2_desc.length <= 0)
			return '#ffffff';

		return c2js(settings.color2);
	}

	function color2Changed(color, event) {
		let c = (color.rgb.r << 16) | (color.rgb.g << 8) | color.rgb.b;
		setSettings({...settings, color2: c});
		setChanged(true);
	}

	function stateWizChanged(event, value) {
		setSettings({...settings, statewiz: value ? 1 : 0});
		setChanged(true);
	}

	function blNotificationChanged(event, value) {
		setSettings({...settings, bl_notification: value ? 1 : 0});
		setChanged(true);
	}

	function speechRecChanged(event, value) {
		setSettings({...settings, speech_rec: value ? 1 : 0});
		setChanged(true);
	}

	function tripSnacBarChanged(event, value) {
		setSettings({...settings, trip_snackbar: value ? 1 : 0});
		setChanged(true);
	}

	/* Admin operations ------------------------------------------------- */

	function delUser() {
		if (!window.confirm(t('settings.del_conf')))
			return;

// 		console.log('delUser', settings.id);

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'del',
			data: {
				user: settings,
			}
		};

		saving = 1;
		gStorage.conn.ws.send(msg, settingsRxWs);
	}

	function pwdReset() {
		if (!settings.first_name.length) {
			alert('Empty first name!');
			return;
		}

		if (!window.confirm(t('settings.pwd_reset_conf')))
			return;

		const year = new Date().getYear() + 1900;
		let pwd = settings.first_name.substring(0, 1).toUpperCase();

		pwd += settings.first_name.substring(1, settings.first_name.length);
		pwd += year;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'user',
			op: 'password',
			data: {
				user: {
					id: settings.id,
					passwd: pwd,
				}
			}
		};

// 		console.log('pwdReset', msg);
		gStorage.conn.ws.send(msg, settingsRxWs);
	}

	function deleteButton() {
		if (!settings.id || settings.id === 0 || settings.id === gStorage.conn.user.id || !(gStorage.conn.user._access & JSP_ADD_USER))
			return null;

		return (
			<Button 
				variant="contained" 
				color="primary" 
				size="small" 
				style={{width:143, margin: 8}} 
				disabled={saving > 0}
				onClick={delUser}>
					{t('add.del')}
			</Button>
		);
	}

	function adminFeatures() {
		if (settings.id === gStorage.conn.user.id || !(gStorage.conn.user._access & JSP_MOD_USER))
			return null;

		return (
			<div>
				<div>
					<Grid size={{xs: 12}} align={'center'}>
						<FormControlLabel
							label={t('settings.force_password')}
							labelPlacement="start"
							checked={!!settings.pwd_reset_req}
							onChange={pwdResetReqChanged}
							control={<Checkbox color="primary" />}
							style={{margin: 8}}
						/>
					</Grid>
					<Grid size={{xs: 12}} align={'center'}>
						<FormControlLabel
							label={t('settings.no_login')}
							labelPlacement="start"
							checked={!!settings.no_login}
							onChange={noLoginChanged}
							control={<Checkbox color="primary" />}
							style={{margin: 8}}
						/>
					</Grid>
				</div>
				<Button 
					variant="contained" 
					color="primary" 
					size="small" 
					style={{width:300, margin: 4}} 
					disabled={!gStorage.conn.online || saving > 0 || settings.first_name.length <= 0}
					onClick={pwdReset}>
						{t('settings.reset_password')}
				</Button>
			</div>
		);
	}

	function getheader() {
		switch (gStorage.settings.em) {
			case EM_SELF: 
				return t('settings.own_settings');
			case EM_OTHER:
				return t('settings.user_settings');
			case EM_NEW:
				return t('settings.new_user_settings');
			default:
				/* Nothing here */
				break;
		}

		console.error('settings getheader: invalid em', gStorage.settings.em, '!');
		return "";
	}

	/* ------------------------------------------------------------------ */

	return (
        	<div>
			<ObsAppBar getheader={getheader} close_action={handleCancel}/>
        		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
    					{nick_object()}
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.first_name')}
						variant="outlined"
						value={settings.first_name}
						error={!validFirstName()}
						onChange={firstNameChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.last_name')}
						variant="outlined"
						value={settings.last_name}
						error={!validLastName()}
						onChange={lastNameChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Autocomplete
						options={gStorage.lists.citylist.list}
						getOptionLabel={option => setGetCityName(option)}
						value={settings.city}
						onChange={cityChange}
						error={settings.city_id <= 0 ? 1 : 0}
						autoSelect
						disableClearable
						style={{width: 300, margin: 8}}
						renderInput={params => (
							<TextField {...params} label={t('settings.city')} variant="outlined" size="small" fullWidth />
						)} />
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.street_addr')}
						variant="outlined"
						value={settings.street_addr}
						onChange={streetAddrChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.city_addr')}
						variant="outlined"
						value={settings.city_addr}
						onChange={cityAddrChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.email')}
						variant="outlined"
						value={settings.email}
						error={!validEmail()}
						onChange={emailChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.phone')}
						variant="outlined"
						value={settings.phone}
						error={!validPhone()}
						onChange={phoneChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('settings.pri_spec_lang')}</InputLabel>
						<Select
							value={settings.pri_spec_lang}
							onChange={primarySpecLangChanged}
							style={{width: 300, margin: 8}}
						>
						{
							priLangList.map((lang, ind) => {
								return (<MenuItem key={lang.id} value={lang.id}>{lang.name}</MenuItem>);
							})
						}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('settings.sec_spec_lang')}</InputLabel>
						<Select
							value={settings.sec_spec_lang}
							onChange={secondarySpecLangChanged}
							style={{width: 300, margin: 8}}
						>
						{
							secLangList.map((lang, ind) => {
								return (<MenuItem key={lang.id} value={lang.id}>{lang.name}</MenuItem>);
							})
						}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('settings.city_lang')}</InputLabel>
						<Select
							value={settings.city_lang}
							onChange={cityLangChanged}
							style={{width: 300, margin: 8}}
						>
						{
							cityLangList.map((lang, ind) => {
								return (<MenuItem key={lang.id} value={lang.id}>{lang.name}</MenuItem>);
							})
						}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.public_obs')}
						labelPlacement="start"
						checked={!!settings.public_obs}
						onChange={publicObsChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.allow_friend')}
						labelPlacement="start"
						checked={!!settings.allow_friend}
						onChange={allowFriendChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('trips.trip1')}</InputLabel>
						<Select
							value={settings.trip1}
							onChange={trip1Changed}
							style={{width: 300, margin: 8}}>
								{tripList1()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('trips.trip2')}</InputLabel>
						<Select
							value={settings.trip2}
							onChange={trip2Changed}
							style={{width: 300, margin: 8}}>
								{tripList2()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('trips.trip3')}</InputLabel>
						<Select
							value={settings.trip3}
							onChange={trip3Changed}
							style={{width: 300, margin: 8}}>
								{tripList3()}
						</Select>
					</FormControl>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.chk1_desc')}
						variant="outlined"
						value={settings.chk1_desc}
						onChange={chk1DescChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.chk2_desc')}
						variant="outlined"
						value={settings.chk2_desc}
						onChange={chk2DescChanged}
						size="small" 
						style={{width: 300, margin: 8}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.color1_desc')}
						variant="outlined"
						value={settings.color1_desc}
						onChange={color1DescChanged}
						size="small" 
						style= {{width: 300, margin: 8, backgroundColor: c1bgColor()}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<GithubPicker
					color={settings.color1}
					onChangeComplete={color1Changed}
				/>
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('settings.color2_desc')}
						variant="outlined"
						value={settings.color2_desc}
						onChange={color2DescChanged}
						size="small" 
						style={{width: 300, margin: 8, backgroundColor: c2bgColor()}}
						inputProps={{maxLength: 80}}
					/>
				</Grid>
				<GithubPicker
					color={settings.color2}
					onChangeComplete={color2Changed}
				/>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.use_statewizard')}
						labelPlacement="start"
						checked={!!settings.statewiz}
						onChange={stateWizChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.bl_notifications')}
						labelPlacement="start"
						checked={!!settings.bl_notification}
						onChange={blNotificationChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.speech_recognition')}
						labelPlacement="start"
						checked={!!settings.speech_rec}
						onChange={speechRecChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('settings.trip_snackbar')}
						labelPlacement="start"
						checked={!!settings.trip_snackbar}
						onChange={tripSnacBarChanged}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				{adminFeatures()}
				<Grid size={{xs: 12}} align={'center'}>
					<Button 
						variant="contained" 
						color="primary" 
						size="small" 
						style={{width:143, margin: 8}} 
						disabled={!gStorage.conn.online ||!changed || !validPhone() || !validEmail() || !validFirstName() || !validLastName() || !validNick() || saving > 0}
						onClick={saveSettings}>
							{t('add.save')}
					</Button>
					{deleteButton()}
				</Grid>
			</Grid>
		</div>
	);
}

export default Settings;
